import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

const Footer = props => {
  const { copyright } = props;
  return (
    <Fragment>
      <div className="p-3 mb-2 bg-dark text-white text-center">
        &copy;2019  <a href="https://jakdev047.github.io/">{ copyright }</a>
      </div>
    </Fragment>
  );
}
Footer.defaultProps = {
  copyright: 'Jubayer Alam Khan'
};

Footer.propTypes = {
  copyright: PropTypes.string.isRequired
};
export default Footer;
